import "./ToolBarTemplate.scss";
import { FC, ReactNode } from "react";
import { AppBar, Toolbar } from "@mui/material";
import { IyilestirIcons } from "../../../__product__/assets/icons/IyilestirIcons";
import { CompanyInfoModel } from "../../../api/model/response/CompanyInfoModel";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../__product__/navigation/routes";
import { getImage } from "../../../api/ApiPath";
import { useMyNavigate } from "../../../__product__/navigation/myNavigate";
import { useUserContext } from "../../../context/UserContext";

type Props = {
  children?: ReactNode;
  company?: CompanyInfoModel;
  backgroundColor?: string;
  titleColor?: string;
};
const ToolBarTemplate: FC<Props> = ({ children, company, backgroundColor, titleColor }) => {
  const navigate = useMyNavigate();

  return (
    <div>
      <AppBar
        style={{
          border: "none",
          background: backgroundColor ?? "var(--helper-danger-900)"
        }}
        elevation={0}
        className={"appbar"}
        position="static"
      >
        <Toolbar style={{ justifyContent: "space-between", border: "none" }}>
          <div className={"logo-area"}>
            <div
              role={"button"}
              onClick={() => {
                navigate(routes.initial);
              }}
              style={{ color: titleColor ?? "white" }}
              className={"iyilestir-caption-medium"}
            >
              {company?.logoPhotoUrl ? (
                <img className="toolbar-logo" src={getImage(company?.logoPhotoUrl)} />
              ) : (
                <>{company?.title}</>
              )}
            </div>
          </div>
          <div
            style={{ color: titleColor ?? "white" }}
            className={"toolbar-logo"}
            onClick={() => (window.location.href = "http://www.iyilestir.com")}
          >
            {IyilestirIcons.logo}
          </div>
        </Toolbar>
      </AppBar>
      {children}
    </div>
  );
};
export default ToolBarTemplate;
